import * as actionTypes from './actionTypes';
import constants from "../../utils/constants";

const log = require("loglevel").getLogger("coSellOpportunityReducer");
log.setLevel("debug");

const initialState = JSON.stringify({
	coSellOpportunities: null,
	total: 0
});

function coSellOpportunityReducer(state = JSON.parse(initialState), action) {
	switch (action.type) {
		case constants.GLOBAL_ACTION_INIT_STATE: {
			log.debug("reset coSellOpportunity state");
			return initialState;
		}
		case actionTypes.CO_SELL_OPPORTUNITIES_LOADED: {
			return {
				...state,
				coSellOpportunities: action.data,
				total: action.total
			};
		}
		default:
			return state;
	}
}

export default coSellOpportunityReducer; 